import { Trans } from '@lingui/react'

import { useAppConfig } from '@twisto/base/app-config'
import { Typography } from '@twisto/components/atoms/typography'

export const ContractDocumentDisclaimer = () => {
  const { region } = useAppConfig()

  switch (region) {
    case 'PL':
      return (
        <Typography align="center" color="textSecondary" variant="b4">
          <Trans id="flow.components.installment.contracts.disclaimer.pl" />
        </Typography>
      )
    case 'CZ':
      return (
        <Typography align="center" color="textSecondary" variant="b4">
          <Trans id="flow.components.installment.contracts.disclaimer.cz" />
        </Typography>
      )
    default:
      return null
  }
}
